import emptyReducer from './emptyReducer';

const toOptionalBoolean = emptyReducer<boolean | undefined>(undefined).with({
  YesNo: (question, positive) => positive,
});

export default toOptionalBoolean;
